import { useOrderIsSelected, useToggleOrder } from '@montugroup/circuit-shared/context/table/OrderSelectionContext';
import { Checkbox } from '@montugroup/design-system';

function OrderSelectionTableCell({ id, disabled = false }: { id: number; disabled?: boolean }) {
  const isSelected = useOrderIsSelected(id);
  const toggle = useToggleOrder();

  return <Checkbox checked={isSelected} onChange={() => toggle(id)} disabled={disabled} />;
}

export default OrderSelectionTableCell;
